import { call, put } from 'redux-saga/effects';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  INVENTORY_ITEMS_DETAILS,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchInventoryItemDetails = async gid => axiosAuthInstance.get(`${API_END_POINTS.GET_INVENTORY_ITEM}/${gid}`);

export function* getInventoryItemDetails(action) {
  try {
    yield put({ type: LOADING.SET });
    if (action.payload) {
      const { data: { entity } } = yield call(fetchInventoryItemDetails, action.payload);
      yield put({ type: INVENTORY_ITEMS_DETAILS.SUCCESS, payload: entity });
    } else {
      const { data: { entity } } = yield call(fetchInventoryItemDetails, action);
      yield put({ type: INVENTORY_ITEMS_DETAILS.SUCCESS, payload: entity });
    }
  } catch (e) {
    yield put({ type: INVENTORY_ITEMS_DETAILS.FAILED, payload: e.response.data });
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.UNSET });
  }
}
